// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 9i1MabS652V3
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import NewSelectState from "../../NewSelectState"; // plasmic-import: qJ5gCB8LACfk/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicViewDebtor.module.css"; // plasmic-import: 9i1MabS652V3/css
import image16ODavTq3D1X0 from "./images/image16.png"; // plasmic-import: oDav-TQ3d1x0/picture

createPlasmicElementProxy;

export const PlasmicViewDebtor__VariantProps = new Array();

export const PlasmicViewDebtor__ArgProps = new Array();

const $$ = {};

function PlasmicViewDebtor__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "debtorName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "email.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "phoneNumber.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "address1.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "city.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "zip.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "creditorName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "debtSituation.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "productName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__zh7Po)}>
              <Stack__
                as={"div"}
                data-plasmic-name={"invoiceDetails"}
                data-plasmic-override={overrides.invoiceDetails}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceDetails)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__osPlQ)}>
                  <div
                    data-plasmic-name={"title4"}
                    data-plasmic-override={overrides.title4}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title4
                    )}
                  >
                    {"Debtor Information"}
                  </div>
                  <div
                    data-plasmic-name={"title12"}
                    data-plasmic-override={overrides.title12}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title12
                    )}
                  >
                    {
                      "Add as much information as you can about the outstanding payment that you want to collect"
                    }
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__l7Oxn)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__i5UU
                    )}
                  >
                    {"Debtor Name"}
                  </div>
                  <input
                    data-plasmic-name={"debtorName"}
                    data-plasmic-override={overrides.debtorName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.debtorName
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "debtorName",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"Full Name"}
                    ref={ref => {
                      $refs["debtorName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["debtorName", "value"]) ??
                      ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"debtorNameError"}
                  data-plasmic-override={overrides.debtorNameError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtorNameError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Debtor Name is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Debtor Name is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div
                  className={classNames(projectcss.all, sty.freeBox___62Ure)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___17Wbw
                    )}
                  >
                    {"Amount of unpaid debt"}
                  </div>
                  <div
                    data-plasmic-name={"debtAmount"}
                    data-plasmic-override={overrides.debtAmount}
                    className={classNames(projectcss.all, sty.debtAmount)}
                  />
                </div>
                <div
                  data-plasmic-name={"debtAmountError"}
                  data-plasmic-override={overrides.debtAmountError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtAmountError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Amount of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Amount of debt is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__yj3Ng)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__w2Bs
                    )}
                  >
                    {
                      "Delinquency Date (when your customer's payment was originally due)"
                    }
                  </div>
                  <div
                    data-plasmic-name={"debtAge"}
                    data-plasmic-override={overrides.debtAge}
                    className={classNames(projectcss.all, sty.debtAge)}
                  />
                </div>
                <div
                  data-plasmic-name={"debtAgeError"}
                  data-plasmic-override={overrides.debtAgeError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtAgeError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Age of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Delinquency Date is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__hOBhZ)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__lR5HE
                    )}
                  >
                    {"Debtor Phone Number"}
                  </div>
                  <input
                    data-plasmic-name={"phoneNumber"}
                    data-plasmic-override={overrides.phoneNumber}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.phoneNumber
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "phoneNumber",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={``}
                    ref={ref => {
                      $refs["phoneNumber"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, [
                        "phoneNumber",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"debtorPhoneError"}
                  data-plasmic-override={overrides.debtorPhoneError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtorPhoneError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"At least one phone number or email is required"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"At least one phone number or email is required"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__ksf60)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__wx7Us
                    )}
                  >
                    {"Debtor Email"}
                  </div>
                  <input
                    data-plasmic-name={"email"}
                    data-plasmic-override={overrides.email}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.email
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, ["email", "value"])(
                          e.target.value
                        );
                      }).apply(null, eventArgs);
                    }}
                    placeholder={``}
                    ref={ref => {
                      $refs["email"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["email", "value"]) ?? ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"debtorEmailError"}
                  data-plasmic-override={overrides.debtorEmailError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtorEmailError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"At least one phone number or email is required"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"At least one phone number or email is required"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__pyzFh)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__vw04C
                    )}
                  >
                    {"Name of the product or service delivered to the debtor"}
                  </div>
                  <input
                    data-plasmic-name={"productName"}
                    data-plasmic-override={overrides.productName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.productName
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "productName",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={``}
                    ref={ref => {
                      $refs["productName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, [
                        "productName",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"productError"}
                  data-plasmic-override={overrides.productError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.productError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Age of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Name of the product or service is required"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__pAPyy)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__fgcJ5
                    )}
                  >
                    {"Creditor Name (who the debt is owed to)"}
                  </div>
                  <input
                    data-plasmic-name={"creditorName"}
                    data-plasmic-override={overrides.creditorName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.creditorName
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "creditorName",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={``}
                    ref={ref => {
                      $refs["creditorName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, [
                        "creditorName",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"creditorNameError"}
                  data-plasmic-override={overrides.creditorNameError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.creditorNameError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Age of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Creditor Name is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div
                  className={classNames(projectcss.all, sty.freeBox___9Pj62)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__mu1D1
                    )}
                  >
                    {"Debtor's Address or Location (if known)"}
                  </div>
                  <input
                    data-plasmic-name={"address1"}
                    data-plasmic-override={overrides.address1}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.address1
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "address1",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"Address Line"}
                    ref={ref => {
                      $refs["address1"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["address1", "value"]) ??
                      ""
                    }
                  />

                  <input
                    data-plasmic-name={"city"}
                    data-plasmic-override={overrides.city}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.city
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, ["city", "value"])(
                          e.target.value
                        );
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"City"}
                    ref={ref => {
                      $refs["city"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["city", "value"]) ?? ""
                    }
                  />

                  <NewSelectState
                    data-plasmic-name={"state"}
                    data-plasmic-override={overrides.state}
                    className={classNames("__wab_instance", sty.state)}
                  />

                  <input
                    data-plasmic-name={"zip"}
                    data-plasmic-override={overrides.zip}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.zip
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, ["zip", "value"])(
                          e.target.value
                        );
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"ZIP"}
                    ref={ref => {
                      $refs["zip"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["zip", "value"]) ?? ""
                    }
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__w9Co2)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__viAn0
                    )}
                  >
                    {"Debtor's Date of Birth (if known)"}
                  </div>
                  <div
                    data-plasmic-name={"dob"}
                    data-plasmic-override={overrides.dob}
                    className={classNames(projectcss.all, sty.dob)}
                  />
                </div>
                <div
                  className={classNames(projectcss.all, sty.freeBox___7ABwR)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__g6Xiv
                    )}
                  >
                    {"Upload Additional Files"}
                  </div>
                  <div
                    data-plasmic-name={"uploadFiles"}
                    data-plasmic-override={overrides.uploadFiles}
                    className={classNames(projectcss.all, sty.uploadFiles)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___8OsFv
                      )}
                    >
                      {"+  Upload Files"}
                    </div>
                  </div>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__ejWpb
                    )}
                  >
                    {"Download Files"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__pgVjn)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__cqEzK)}
                    >
                      <div
                        data-plasmic-name={"downloadFiles"}
                        data-plasmic-override={overrides.downloadFiles}
                        className={classNames(
                          projectcss.all,
                          sty.downloadFiles
                        )}
                      >
                        <PlasmicImg__
                          data-plasmic-name={"img"}
                          data-plasmic-override={overrides.img}
                          alt={""}
                          className={classNames(sty.img)}
                          displayHeight={"auto"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"12%"}
                          loading={"lazy"}
                          src={{
                            src: image16ODavTq3D1X0,
                            fullWidth: 128,
                            fullHeight: 128,
                            aspectRatio: undefined
                          }}
                        />

                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__srItP
                          )}
                        >
                          {"Download Files"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__hGiUt)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__mupDv
                    )}
                  >
                    {"Description of the Debt Situation"}
                  </div>
                  <textarea
                    data-plasmic-name={"debtSituation"}
                    data-plasmic-override={overrides.debtSituation}
                    className={classNames(
                      projectcss.all,
                      projectcss.textarea,
                      sty.debtSituation
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "debtSituation",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    ref={ref => {
                      $refs["debtSituation"] = ref;
                    }}
                    value={
                      generateStateValueProp($state, [
                        "debtSituation",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
              </Stack__>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {"Please enter all of the required fields"}
              </div>
              <div
                data-plasmic-name={"submitButton"}
                data-plasmic-override={overrides.submitButton}
                className={classNames(projectcss.all, sty.submitButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__wFfw1
                  )}
                >
                  {hasVariant(globalVariants, "screen", "medium")
                    ? "Submit"
                    : "Update Debtor"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "vertStack",
    "invoiceDetails",
    "title4",
    "title12",
    "debtorName",
    "debtorNameError",
    "debtAmount",
    "debtAmountError",
    "debtAge",
    "debtAgeError",
    "phoneNumber",
    "debtorPhoneError",
    "email",
    "debtorEmailError",
    "productName",
    "productError",
    "creditorName",
    "creditorNameError",
    "address1",
    "city",
    "state",
    "zip",
    "dob",
    "uploadFiles",
    "downloadFiles",
    "img",
    "debtSituation",
    "errorText",
    "submitButton"
  ],

  sidebar: ["sidebar"],
  vertStack: [
    "vertStack",
    "invoiceDetails",
    "title4",
    "title12",
    "debtorName",
    "debtorNameError",
    "debtAmount",
    "debtAmountError",
    "debtAge",
    "debtAgeError",
    "phoneNumber",
    "debtorPhoneError",
    "email",
    "debtorEmailError",
    "productName",
    "productError",
    "creditorName",
    "creditorNameError",
    "address1",
    "city",
    "state",
    "zip",
    "dob",
    "uploadFiles",
    "downloadFiles",
    "img",
    "debtSituation",
    "errorText",
    "submitButton"
  ],

  invoiceDetails: [
    "invoiceDetails",
    "title4",
    "title12",
    "debtorName",
    "debtorNameError",
    "debtAmount",
    "debtAmountError",
    "debtAge",
    "debtAgeError",
    "phoneNumber",
    "debtorPhoneError",
    "email",
    "debtorEmailError",
    "productName",
    "productError",
    "creditorName",
    "creditorNameError",
    "address1",
    "city",
    "state",
    "zip",
    "dob",
    "uploadFiles",
    "downloadFiles",
    "img",
    "debtSituation"
  ],

  title4: ["title4"],
  title12: ["title12"],
  debtorName: ["debtorName"],
  debtorNameError: ["debtorNameError"],
  debtAmount: ["debtAmount"],
  debtAmountError: ["debtAmountError"],
  debtAge: ["debtAge"],
  debtAgeError: ["debtAgeError"],
  phoneNumber: ["phoneNumber"],
  debtorPhoneError: ["debtorPhoneError"],
  email: ["email"],
  debtorEmailError: ["debtorEmailError"],
  productName: ["productName"],
  productError: ["productError"],
  creditorName: ["creditorName"],
  creditorNameError: ["creditorNameError"],
  address1: ["address1"],
  city: ["city"],
  state: ["state"],
  zip: ["zip"],
  dob: ["dob"],
  uploadFiles: ["uploadFiles"],
  downloadFiles: ["downloadFiles", "img"],
  img: ["img"],
  debtSituation: ["debtSituation"],
  errorText: ["errorText"],
  submitButton: ["submitButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicViewDebtor__ArgProps,
          internalVariantPropNames: PlasmicViewDebtor__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicViewDebtor__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicViewDebtor";
  } else {
    func.displayName = `PlasmicViewDebtor.${nodeName}`;
  }
  return func;
}

export const PlasmicViewDebtor = Object.assign(
  // Top-level PlasmicViewDebtor renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    vertStack: makeNodeComponent("vertStack"),
    invoiceDetails: makeNodeComponent("invoiceDetails"),
    title4: makeNodeComponent("title4"),
    title12: makeNodeComponent("title12"),
    debtorName: makeNodeComponent("debtorName"),
    debtorNameError: makeNodeComponent("debtorNameError"),
    debtAmount: makeNodeComponent("debtAmount"),
    debtAmountError: makeNodeComponent("debtAmountError"),
    debtAge: makeNodeComponent("debtAge"),
    debtAgeError: makeNodeComponent("debtAgeError"),
    phoneNumber: makeNodeComponent("phoneNumber"),
    debtorPhoneError: makeNodeComponent("debtorPhoneError"),
    email: makeNodeComponent("email"),
    debtorEmailError: makeNodeComponent("debtorEmailError"),
    productName: makeNodeComponent("productName"),
    productError: makeNodeComponent("productError"),
    creditorName: makeNodeComponent("creditorName"),
    creditorNameError: makeNodeComponent("creditorNameError"),
    address1: makeNodeComponent("address1"),
    city: makeNodeComponent("city"),
    state: makeNodeComponent("state"),
    zip: makeNodeComponent("zip"),
    dob: makeNodeComponent("dob"),
    uploadFiles: makeNodeComponent("uploadFiles"),
    downloadFiles: makeNodeComponent("downloadFiles"),
    img: makeNodeComponent("img"),
    debtSituation: makeNodeComponent("debtSituation"),
    errorText: makeNodeComponent("errorText"),
    submitButton: makeNodeComponent("submitButton"),
    // Metadata about props expected for PlasmicViewDebtor
    internalVariantProps: PlasmicViewDebtor__VariantProps,
    internalArgProps: PlasmicViewDebtor__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicViewDebtor;
/* prettier-ignore-end */
